/**
 * @description 指标采集配置 kpiInterval
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const kpiIntervalBiz = new Logic()

kpiIntervalBiz.save = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.kpiInterval.save,
    data: data
  })
}

export default kpiIntervalBiz
